import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { useRightPanel } from '@/contexts/RightPanelContext';

/**
 * NavigationTracker component
 * 
 * This component tracks route changes and notifies the RightPanelContext
 * so it can manage panel state per page. It must be placed inside a Router.
 * 
 * It detects back/forward navigation to preserve filter state.
 */
export function NavigationTracker() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const { onNavigate } = useRightPanel();
  const previousPathRef = useRef<string>('');

  useEffect(() => {
    // Detect if this is a back/forward navigation
    const isBackNavigation = navigationType === 'POP';
    
    // Only notify if the path actually changed
    if (location.pathname !== previousPathRef.current) {
      onNavigate(location.pathname, isBackNavigation);
      previousPathRef.current = location.pathname;
    }
  }, [location.pathname, navigationType, onNavigate]);

  return null; // This component doesn't render anything
}
